import React, { useState, useEffect, useRef } from 'react';
import Sidebar_left from './Sidebar_left';
import { Link } from 'react-router-dom';

const Profesional_Membresia_TY = () => {
    return (
        <>
            <div className='container-profesional page-membresia container-section'>
                <div className='left-side'>
                    <Sidebar_left />
                </div>
                <div className="right-side">
                    <div className='sticky-form'>
                        <Link to="/profesional/membresia" className="button-primary">Volver</Link>
                    </div>
                    <h4>Tu membresia ha sido actualizada, disfruta de los nuevos beneficios</h4>
                </div>
            </div>
        </>
    );
};

export default Profesional_Membresia_TY;
